import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_bev_2: FaireProductEntity = {
  token: "nyc-bev-2",
  type: "product",
  name: "Sparkling Apple Juice",
  brandName: "Lovely Branch",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/d3536a31a25a764ec8df300e640932116da4e34077e080660c443f76eb9994cf.webp",
  priceDollars: 7.5,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/d3536a31a25a764ec8df300e640932116da4e34077e080660c443f76eb9994cf.webp",
  weight: 0.7,
  dimensions: {
    width: 3,
    height: 8,
    depth: 3,
  },
  description:
    "Juicy, extra tart, naturally sweet sparkling apple juice from Northeast apples",
  categoryTokens: ["cat_food-beverages"],
  tags: ["premium", "organic", "sparkling", "juice"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
